import { MembershipsV1Currency } from '@sdk/Api'
import { derived, writable } from 'svelte/store'

export const isUsd = writable(true)

export const pricingCurrency = derived([isUsd], ([$isUsd]) => {
	return $isUsd ? MembershipsV1Currency.CURRENCY_USD : MembershipsV1Currency.CURRENCY_EUR
})
